<template>
    <div>
        <div>
            <vx-card title="Codigos Liquidados/Regalados Plan Lector">
                <div>
                    <vs-row style="margin: 0px 0px 20px 0px">
                        <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                            <vs-col vs-justify="center" vs-align="center" vs-w="10" class="m-2">
                                <font style="font-size: 11.5px">&nbsp;Temporada:</font><br />
                                <v-select :value="selected" :options="temporada" :reduce="temporada => temporada.idperiodoescolar" label="periodoescolar" class="w-full" v-model="codtemporada" @input="listaCodigos=[];getCodigosPlanlectorLiquidadoRegalado();" @keyup.enter="getCodigosPlanlectorLiquidadoRegalado()" />
                            </vs-col>
                        </vs-row>
                    </vs-row>
                </div>
                <div v-if="codtemporada">
                    <vs-row vs-type="flex" vs-lg="12" vs-sm="12" vs-xs="12" > 
                        <vs-col vs-type="flex" vs-align="center" vs-lg="4" vs-sm="6" vs-xs="12">
                            <vx-card fixed-height="true" class="m-3 orange">
                                <span class="font-bold">Codigos Liquidados</span><br>
                                <h4 class="font-bold text-orange">{{ totalLiquidados }}</h4>
                            </vx-card>
                        </vs-col>
                        <vs-col vs-type="flex" vs-align="center" vs-lg="4" vs-sm="6" vs-xs="12">
                            <vx-card fixed-height="true" class="m-3 blue">
                                <span class="font-bold">Codigos Regalados</span><br>
                                <h4 class="font-bold text-blue">{{ totalRegalados }}</h4>
                            </vx-card>
                        </vs-col>
                        <!-- <vs-col vs-type="flex" vs-align="center" vs-lg="4" vs-sm="6" vs-xs="12">
                            <vx-card fixed-height="true" class="m-3 orange">
                                <span class="font-bold">Codigos Liquidados-Regalados</span><br>
                                <h4 class="font-bold text-orange">{{ totalLiquidadosRegalados }}</h4>
                            </vx-card>
                        </vs-col>
                        <vs-col v-if="listaCodigos.length>1000000000000000000" vs-type="flex" vs-align="center" vs-lg="4" vs-sm="6" vs-xs="12">                           
                                <vs-button icon-pack="feather" icon="icon-file" color="success" type="border" class="m-3 w-full" @click="generarExcel();">Generar Excel</vs-button>
                        </vs-col> -->
                    </vs-row>      
                </div>
                <vs-table max-items="20" pagination search :data="listaCodigos">
                    <template slot="header" v-if="listaCodigos.length>0">
                        <vs-button color="success" type="border" class="m-3" @click="arrayExcel=[];generarExcel();"> <i class="fa-solid fa-file-arrow-down"></i> Exportar Excel</vs-button>
                    </template>
                    <template slot="thead">
                        <vs-th style="color: black; font-size: 15px;">Código</vs-th>
                        <vs-th style="color: black; font-size: 15px;">Libro</vs-th>
                        <vs-th style="color: black; font-size: 15px;">Códigos Liquidados</vs-th>
                        <vs-th style="color: black; font-size: 15px;">Códigos Regalados</vs-th>
                        <vs-th style="color: black; font-size: 15px;">Total Códigos</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td style="color: black; font-size: 14.5px;">{{ tr.codigo_liquidacion }}</vs-td>
                            <vs-td style="color: black; font-size: 14.5px;">{{ tr.nombre }}</vs-td>
                            <vs-td style="color: black; font-size: 14.5px;">{{ tr.codigos_liquidados }}</vs-td>
                            <vs-td style="color: black; font-size: 14.5px;">{{ parseInt(tr.codigos_regalado) + parseInt(tr.codigos_regalado_liquidado) }}</vs-td>
                            <vs-td style="color: black; font-size: 14.5px;">{{ parseInt(tr.codigos_liquidados) + parseInt(tr.codigos_regalado) + parseInt(tr.codigos_regalado_liquidado) }}</vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </vx-card>
        </div>
    </div>
    </template>
    
    <script>
    import vSelect from 'vue-select';
    export default {
        data() {
            return {
                listaCodigos: [],
                temporada: [],
                arrayExcel : [],
                codtemporada: '',
                selected: null,
                datosCodigos: false,
                totalLiquidados: 0,
                totalRegalados: 0,
                totalLiquidadosRegalados: 0,
            };
        },
        computed: {
            totalCodigosLiquidados() {
                return this.sumarColumna('codigos_liquidados');
            },
            totalCodigosRegalados() {
                return this.sumarColumna('codigos_regalado');
            },
            totalCodigosRegaladosLiquidados() {
                return this.sumarColumna('codigos_regalado_liquidado');
            }
        },
        watch: {
            listaCodigos: {
                handler(newVal, oldVal) {
                    // Recalcular totales cuando listaCodigos cambie
                    this.totalLiquidados = this.totalCodigosLiquidados;
                    this.totalRegalados = this.totalCodigosRegalados + this.totalCodigosRegaladosLiquidados;
                    // this.totalLiquidadosRegalados = this.totalCodigosRegaladosLiquidados;
                },
                deep: true
            }
        },
        mounted() {
            let me = this;
            me.getTemporada();
        },
        methods: {
            sumarColumna(columna) {
                return this.listaCodigos.reduce((total, tr) => total + parseInt(tr[columna] || 0), 0);
            },
            getTemporada() {
                this.$http.get(this.$server_url + 'get_periodos_pedidos')
                    .then(res => {
                        let datos = res.data;
                        if (datos.length === 0) {
                            this.temporada = [];
                            return;
                        }
    
                        let years = [2019, 2018, 2017, 2016];
                        let regions = ['Costa', 'Sierra'];
    
                        years.forEach(year => {
                            regions.forEach(region => {
                                let datosAdd = {
                                    periodoescolar: region + ' ' + year,
                                    codigo_contrato: region[0] + year.toString().slice(-2)
                                };
                                datos.push(datosAdd);
                            });
                        });
    
                        this.temporada = datos.filter(item => !/prueba|test|demo/i.test(item.periodoescolar) && item.codigo_contrato !== null);
                    })
                    .catch(error => {
                        this.$vs.loading.close();
                    });
            },
            getCodigosPlanlectorLiquidadoRegalado() {
                let me = this;
                if (me.codtemporada) {
                    me.$vs.loading();
                    this.$http.get(this.$server_url + 'getCodigosPlanlectorLiquidadoRegalado?periodo=' + me.codtemporada)
                        .then(res => {
                            me.listaCodigos = res.data;
                            me.$vs.loading.close();
                        })
                        .catch(err => {
                            console.error(err);
                            me.$vs.loading.close();
                        });
                } else {
    
                }
    
            },
            generarExcel(){
                let me = this;
                // console.log(me.listaCodigos);
                me.listaCodigos.forEach(item => {
                    this.calcularSumas(item);
                });
                me.$vs.loading();
                setTimeout(() => {
                    this.exportToExcel();
                    me.$vs.loading.close()
                }, 2000);
            },
            exportToExcel() {
                let me = this;                
                let headerTitle = ""
                let headerVal = ""

                headerTitle = [
                    'CÓDIGO', //1
                    'LIBRO', //2
                    'CÓDIGOS LIQUIDADOS', //3
                    'CÓDIGOS REGALADOS', //4
                    'TOTAL CÓDIGOS', //5
                ];

                headerVal = [
                    'codigo_liquidacion', //1
                    'nombre', //2
                    'codigos_liquidados', //3
                    'codigos_regaladosliquidados', //4
                    'total', //5
                ];

                import('@/vendor/Export2Excel').then(excel => {
                    const data = this.formatJson(headerVal, me.arrayExcel);
                    excel.export_json_to_excel({
                        header: headerTitle,
                        data,
                        filename: `codigosPlanLector_${me.codtemporada}`,
                        autoWidth: this.cellAutoWidth,
                        bookType: this.selectedFormat
                    });

                    this.clearFields();
                }).catch(error => {
                    console.error('Error en la exportación a Excel:', error);
                });
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                    return v[j]
                }))
            },
            clearFields() {
                this.fileName = 'codigosPlanLector';
                this.cellAutoWidth = true;
                this.selectedFormat = 'xlsx';
            },
            calcularSumas(item) {
                let me = this;
                let codigos_regalado = parseInt(item.codigos_regalado) || 0;
                let codigos_regalado_liquidado = parseInt(item.codigos_regalado_liquidado) || 0;
                let codigos_liquidados = parseInt(item.codigos_liquidados) || 0;

                let codigos_regaladosliquidados = codigos_regalado + codigos_regalado_liquidado;
                let total = codigos_liquidados + codigos_regalado + codigos_regalado_liquidado;

                me.arrayExcel.push({
                    codigo_liquidacion: item.codigo_liquidacion,
                    nombre: item.nombre,
                    codigos_liquidados,
                    codigos_regaladosliquidados,
                    total
                });                
            },

    
        },
        components: {
            'v-select': vSelect,
        },
    };
    </script>
    
    <style>
    .orange {
        border-bottom: 3px solid hsl(27, 92%, 61%);
        border-top: 3px solid hsl(27, 92%, 61%);
    }
    
    .blue {
        border-bottom: 3px solid hsl(216, 92%, 61%);
        border-top: 3px solid hsl(216, 92%, 61%);
    }
    .text-blue{
        color: hsl(216, 92%, 61%);
    }
    </style>
    